import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import isEmpty from "lodash/isEmpty";
import { parse } from "query-string";
import jwtDecode from "jwt-decode";
import { receiveAccessToken, receiveIdToken } from "../redux/token/tokenSlice";
import { DashboardLoader } from "../utils/Loading";
import { getUserDetails } from "../redux/profile/profileSlice";
import { useAuthLogout } from "../api/oidcApi";
import { GetLocalStore } from "../utils/storage";

export const checkUserAccess = (obj) => {
  if (obj.permissions.length >= 1) {
    return true;
  }
  return false;
};

const Auth = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const handleLogout = useAuthLogout();

  const receiveProfile = (data) => {
    dispatch(getUserDetails(data));
  };

  const receiveTokens = (accessToken, idToken) => {
    dispatch(receiveAccessToken(accessToken));
    dispatch(receiveIdToken(idToken));
  };
  const { profile = null, token = null } = useSelector((state) => state);

  useEffect(() => {
    if (isEmpty(profile)) {
      // Step 1: Profile not loaded yet — parse tokens from Okta hash
      const hash = location.hash;
      const response = parse(hash);

      // Guard: no tokens in hash, nothing to do
      if (!response.id_token && !response.access_token) {
        console.warn("Auth: No tokens in hash, skipping. Hash:", hash);
        return;
      }

      if (response.error) {
        navigate("/403");
      } else {
        try {
          receiveTokens(response.access_token, response.id_token);
          receiveProfile(jwtDecode(response.id_token));
        } catch (e) {
          console.error("Auth: Failed to decode token:", e);
          navigate("/403");
        }
      }

    } else {
      // Step 2: Profile loaded — handle redirect
      const fromLocation = location.state?.from;
      const storedRedirect = localStorage.getItem("post_login_redirect");

      const rfcRedirect = fromLocation?.pathname?.includes('/rfc-library/')
        ? fromLocation.pathname + (fromLocation.search || '')
        : storedRedirect?.includes('/rfc-library/')
          ? storedRedirect
          : null;

      console.log("Auth: rfcRedirect =", rfcRedirect);

      // Always clean up storage
      localStorage.removeItem("post_login_redirect");

      if (rfcRedirect) {
        if (checkUserAccess(profile)) {
          console.log("Auth: Navigating to RFC path:", rfcRedirect);
          navigate(rfcRedirect);
          return;
        } else {
          handleLogout();
          navigate("/403");
          return;
        }
      }

      // Normal login flow
      const redirectTo = GetLocalStore("path");
      if (checkUserAccess(profile)) {
        if (!redirectTo || redirectTo === "") {
          navigate("/");
        } else if (redirectTo !== "/" && redirectTo !== "/admin") {
          navigate(redirectTo);
        } else {
          navigate("/admin");
        }
      } else {
        handleLogout();
        navigate("/403");
      }
    }
  }, [profile]);

  return <DashboardLoader />;
};

export default Auth;